export const moneyConverter = (price: string) => {
  let replacedCommas = price.replace(",", ".");
  let replacedWhitespace = replacedCommas.replace(" ", "");
  return parseFloat(replacedWhitespace);
};

export const getSubdomain = (): string => {
  return window.location.host;
};
